import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { BtTextboxModel } from '../bt-textbox.model';

@Component({
    selector: 'bt-textbox-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => BtTextboxFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => BtTextboxFormComponent),
        multi: true
      }
    ],
    templateUrl: './bt-textbox-form.component.html',
    styleUrls: ['./bt-textbox-form.component.scss']
})
export class BtTextboxFormComponent implements ControlValueAccessor {
    @Input() model: BtTextboxModel;
    @Input() value: any;

    propagateChange = (_: any) => {};
    registerOnChange(fn: any) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: string) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onInputChanged(event: any) {
    this.value = event.target.value;
    this.propagateChange(event.target.value);
  }
}